export const hotelValues = {
  name: '',
  id: 0,
  description: '',
  location: '',
  amenities: '',
  accommodation: '',
  meals: '',
  metaTitle: '',
  metaDescription: '',
  metaKeywords: '',
  published: false,
  displayOrder: 0,
  slug: '',
  shortDescription: '',
  street: '',
  city: '',
  postalCode: '',
};
